<template>
    <div class="landing-widget-form">
      <div class="container">
        <div class="row center-lg">
          <div class="col-xs col-xl-10">
            <div class="form-wrapper">
              <div class="form-title align-left headline_h3">
                Fahrzeugwert <span class="highlight">in nur 1 Minute</span> ermitteln
              </div>
              <div class="configurator-wrapper">
                <Preselector />
                <button type="button" class="go-to-wizard" @click="makeRedirect" name="Submit"><span class="text">Auto bewerten</span><i class="fas fa-arrow-right"></i></button>
              </div>
              <div class="bottom-row">
                <a href="/auto-verkaufen/" title="Auto Verkaufen" class="sell-offer">
                  oder kostenlos Auto verkaufen - online oder lokal in deiner Nähe
                </a>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import Preselector from './Preselector';
import queryString from 'query-string';

import 'vue-select/dist/vue-select.css';
import { Api } from '../services/api';
import _ from 'lodash';
import { combineLinkToEvaluation, redirectToEvaluation, redirectToEvaluationNew } from '../services/helpers';

export default {
    name: "ContentWidgetForm",
    components: {
        vSelect,
        Preselector,
    },
    data() {
    return {
      showModal: {
        widget: false,
      },
    }
    },
    computed: {
      selectedOptions: function() {
        return {
          make: this.$store.state.selected.make,
          model: this.$store.state.selected.model,
          year: this.$store.state.selected.year,
        };
      },
    },
    methods: {
      openModal(modalId) {
        this.showModal[modalId] = true;
      },
      closeModal(modalId) {
        this.showModal[modalId] = false;
      },
      makeRedirect() {        
        redirectToEvaluationNew(this.$store, true, 'know_price', 'evaluation_lp');
      },
      redirectToVerkaufen () {
        redirectToEvaluation(this.$store, false);
      },
      addQueryStringAsHidden(form, newLink){
        let url = newLink;
        
        const allInputs = form.querySelectorAll('input[type="hidden"]');
        allInputs.forEach(input => input.remove());

        let index = url.indexOf("?");
        let action = url.slice(0, index)
        let params = url.slice(index);

        const queryObject = queryString.parse(params);
        Object.keys(queryObject).forEach(key => {
          const input = document.createElement('input');

          input.setAttribute('type', 'hidden');
          input.setAttribute('name', key);
          input.setAttribute('value', queryObject[key]);
            
          form.appendChild(input);
        })

        form.setAttribute("action", action);
      }
    },
    watch: {
      selectedOptions: function (newValue) {
      }
    },
    mounted: function() {
      Api.get(this.$store, this.$store.state.step);
    },
}
</script>

<style lang="scss">
    @import "~@/assets/vars";

    .landing-widget-form {
      position:relative;
      background:$light-gray;

      @include breakpoint(frommediumlarge) {
        box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
      }

      @include breakpoint(fromgiant) {
        background:transparent;
        box-shadow:none;
      }

    .form-wrapper {
        position:relative;
        border-radius:10px;
        padding-top:25px;
        padding-bottom:30px;
        z-index:10;

        @include breakpoint(frommediumlarge) {
          padding-top:60px;
          padding-bottom:30px;
        }
        
        @include breakpoint(fromgiant) {
          margin-top:-143px;
          padding-top:50px;
          padding-bottom:30px;
          padding-left:50px;
          padding-right:50px;
          box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
          background:$light-gray;
        }

        @include breakpoint(extralarge) {
          padding-left:80px;
          padding-right:80px;
        }

        @include breakpoint(full) {
          padding-left:30px;
          padding-right:30px;
        }

        @media screen and (min-width:993px) and (max-height:830px) {
          padding-top:50px;
          padding-bottom:30px;
        }

        @media screen and (min-width:993px) and (max-height:750px) {
          padding-top:30px;
          padding-bottom:30px;
        }

        .form-title {
            font-size: 25px;
            line-height:30px;
            margin-bottom:24px;
            font-weight:600;
            text-align:center;

            @include breakpoint(frommediumlarge) {
              text-align:left;
              font-size:30px;
              line-height:34px;

              br {
                display:none;
              }
            }

            @include breakpoint(fromgiant) {
              font-size: 40px;
              line-height:48px;
            }

            @include breakpoint(extralarge) {
              font-size: 45px;
              line-height:52px;
            }
        }

        .configurator-wrapper {

           @include breakpoint(frommediumlarge) {
              display:flex;
              justify-content: space-between;
            }

          button.go-to-wizard {
            width:100%;
            max-height: 74px;
            border-radius:0;
            white-space:nowrap;
            font-size:17px !important;
            line-height: 20px !important;
            padding:12px 0 !important;
            max-height: 60px;

            > i {
              padding-left: 10px;
            }

            @include breakpoint(frommediumlarge) {
              width:25%;
              margin-bottom:0;
              border-top-right-radius:40px;
              border-bottom-right-radius:40px;
              border-top-left-radius:0 !important;
              border-bottom-left-radius:0 !important;
              font-size:15px !important;
              line-height: 17px !important;
            }

            @include breakpoint(fromgiant) {
              width:calc(25% - 2px);
              font-size:17px !important;
              line-height: 20px !important;
            }
          }
        }

        .bottom-row {
          
          @include breakpoint(frommediumlarge) {
            text-align:right;
          }
        }
        
        .sell-offer {
          display: inline-block !important;
            margin-top: 10px !important;
            font-size: 14px !important;
            color: #C0141B !important;
            text-decoration: underline !important;
            cursor: pointer !important;
            text-align: center !important;
            border-radius: 0 !important;
            background: initial !important;
            padding: 0 !important;
            font-weight: initial !important;
            border: initial !important;

            @include breakpoint(frommediumlarge) {
              margin-left: auto;
              // margin-right:0;
              // float:right;
            }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/landing-components/ContentWidgetForm.vue